module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"qualificationLegend":{"good":"More than a month","none":"Not validated","warn":"less than a month"}},"fr":{"qualificationLegend":{"good":"Plus dun mois","none":"Non validé","warn":"Moins d\u0027un mois"}}}')
  delete Component.options._Ctor
}
